import { render, staticRenderFns } from "./_id.tabLayout.vue?vue&type=template&id=2dea9ddb&scoped=true"
import script from "./_id.tabLayout.vue?vue&type=script&lang=js"
export * from "./_id.tabLayout.vue?vue&type=script&lang=js"
import style0 from "./_id.tabLayout.vue?vue&type=style&index=0&id=2dea9ddb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dea9ddb",
  null
  
)

export default component.exports